<template>
  <div id="app" class="sans-serif">
    <transition name="fade">
      <div v-on:click="closeModal" v-if="clickedImage" class="image-overlay z-4 o-100 fixed right-0 top-0">
        <img :src="clickedImage[0].image" style="object-fit: contain;" class="pt5 db h-75 center">
        <div class="tc brown poppins-regular fw5 f3 mt2"> {{clickedImage[0].imageTitle}} </div>
        <div class="tc brown poppins-regular fw5 mt2"> {{clickedImage[0].role}} </div>
        <div class="tc brown poppins-regular fw6 mt2"> {{clickedImage[0].credits}} </div>
      </div>
    </transition>
    <Logo :class="[ clickedImage ? 'blur': '']"/>
    <div :class="[ clickedImage ? 'blur': '']">
      <HelloWorld msg="Welcome to Your Vue.js App"/>
      <Section v-on:showModal="showModal" v-if="designSection" :opts="designSection"/>
      <Section v-on:showModal="showModal" v-if="photographySection" :opts="photographySection"/>
      <Section v-on:showModal="showModal" v-if="brandSection" :opts="brandSection"/>
      <Section v-on:showModal="showModal" v-if="aboutSection" :opts="aboutSection"/>
      <Footer/>
    </div>
  </div>
</template>

<script>
import HelloWorld from './components/HelloWorld.vue'
import Logo from './components/Logo.vue'
import Section from './components/Section.vue'
import Footer from './components/Footer.vue'
import fm from 'front-matter'

export default {
  name: 'app',
  components: {
    HelloWorld,
    Logo,
    Footer,
    Section
  },
  data () {
    return {
      designSection: null,
      photographySection: null,
      brandSection: null,
      aboutSection: null,
      clickedImage: null,
      isModalOpen: false
    }
  },
  methods: {
    showModal: function (image) {
      this.clickedImage = image
    },
    closeModal: function () {
      this.clickedImage = null
    }
  },
  created () {
    fetch('content/sections/design-styling-art-direction.md')
      .then((res) => { return res.text() })
      .then((text) => {
        const content = fm(text)
        // console.log(content)
        const images = content.attributes.images
        const layout = [
          {
            images: [[images[0], 'auto', '384px'], [images[1], '204px', '298px'], [images[2], 'auto', '300px']],
            classes: 'flex flex-wrap items-end mb3'
          },
          {
            images: [[images[3], '264px', '324px'], [images[4], 'auto', '477px'], [images[5], 'auto', '184px']],
            classes: 'flex flex-wrap items-start'
          }
        ]
        this.designSection = {
          title: content.attributes.title,
          description: content.body,
          rows: layout,
          rowClasses: 'flex flex-column mh3',
          hash: 'design'
        }
      })
      .catch((error) => {
        // console.log('error', error)
      })

    fetch('/content/sections/photography.md')
    .then((res) => { return res.text() })
    .then((text) => {
      const content = fm(text)
      const images = content.attributes.images
      const layout = [
        {
          images: [[images[0], '430px', 'auto']],
          classes: 'flex flex-column flex-wrap dib pt6'
        },
        {
          images: [[images[1], '265px', 'auto'], [images[2], '265px', 'auto']],
          classes: 'flex flex-column flex-wrap dib pt6'
        },
        {
          images: [[images[3], '264px', 'auto'], [images[4], '264px', 'auto']],
          classes: 'flex flex-column flex-wrap dib'
        }
      ]
      this.photographySection = {
        title: content.attributes.title,
        description: content.body,
        rows: layout,
        rowClasses: 'flex flex-wrap justify-end',
        hash: 'photo'
      }
    })
    .catch((error) => {
      console.log('error', error)
    })

    fetch('/content/sections/brand-solutions.md')
      .then((res) => { return res.text() })
      .then((text) => {
        const content = fm(text)
        const images = content.attributes.images
        const layout = [
          {
            images: [[images[0], '430px', 'auto'], [images[1], '430px', 'auto']],
            classes: 'flex flex-column flex-wrap dib pt6'
          }
        ]
        this.brandSection = {
          title: content.attributes.title,
          description: content.body,
          rows: layout,
          rowClasses: 'flex flex-wrap justify-start ml7',
          hash: 'brand'
        }
      })
      .catch((error) => {
        console.log('error', error)
      })

    fetch('/content/sections/about.md')
      .then((res) => { return res.text() })
      .then((text) => {
        const content = fm(text)
        const images = content.attributes.images
        const layout = [
          {
            images: [[images[0], '320px', 'auto']],
            classes: 'flex flex-column flex-wrap dib pt6'
          }
        ]
        this.aboutSection = {
          title: content.attributes.title,
          description: content.body,
          rows: layout,
          rowClasses: 'flex flex-wrap justify-start ml5',
          hash: 'about'
        }
      })
      .catch((error) => {
        console.log('error', error)
      })
  }
}
</script>

<style>
body {
  background: #F9F7F4;
}

.link {
  color: #999CDB;
}
.title {
  top: 2rem;
  right: 2rem;
  width: 160px;
}

.brown {
  color: #6F3500;
}

.bg-color {
  background: #F9F7F4;
}

.fixed:after {
  position: fixed;
}

.image-hover {
  -webkit-filter: grayscale(100);
  filter: grayscale(100);
  transition: all 400ms cubic-bezier(0.4, 0, 0, 1) 0s;
  -webkit-backface-visibility: hidden;
  -webkit-perspective: 1000;
}

.grow {
  transition: all 400ms cubic-bezier(0.4, 0, 0, 1) 0s;
  -webkit-backface-visibility: hidden;
  -webkit-perspective: 1000;
}

.grow:hover {
  transform: scale(1.01);
}

.image-hover:hover {
  -webkit-filter: grayscale(0);
  filter: grayscale(0);
  cursor: cell;
}

.image-overlay {
  width: 100vw;
  height: 100vh;
  transition: all 300ms cubic-bezier(0.4, 0, 0, 1) 0s;
  background: #f9f7f4b0;
}

.blur {
  filter: blur(3px);
  -webkit-filter: blur(3px);
  transition: all 400ms cubic-bezier(0.4, 0, 0, 1) 0s;
}

.fade-enter-active, .fade-leave-active {
  xtransition: opacity .5s;
  transition: all 400ms cubic-bezier(0.4, 0, 0, 1) 0s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}

@media screen and (min-width: 30em) {
  .title-ns {
    top: 8rem;
    right: 8rem;
    width: 360px;
  }
}

@font-face {
  font-family: 'Marcellus';
  src: url('assets/fonts/Marcellus-Regular.ttf') format('truetype');
}

@font-face {
  font-family: 'Poppins-Regular';
  src: url('assets/fonts/Poppins-Regular.ttf') format('truetype');
}
@font-face {
  font-family: 'Poppins-Medium';
  src: url('assets/fonts/Poppins-Medium.ttf') format('truetype');
}

.marcellus {
  font-family: 'Marcellus';
}

.poppins-regular {
  font-family: 'Poppins-Regular';
}

.poppins-medium {
  font-family: 'Poppins-Medium';
}

#app {
  -xwebkit-font-smoothing: antialiased;
  -xmoz-osx-font-smoothing: grayscale;
}
</style>
